import { useMemo } from 'react'
import { Select, FormLabel, FormControl, MenuItem } from '@mui/material'
import { SCHOOL_CYCLE_STARTS_AT } from '../../constants'

function SchoolCycleSelect(_props) {
  const {
    wrapperClasses = '',
    labelClasses = '',
    selectClasses = '',
    ...selectProps
  } = _props

  const schoolCycleOptions = useMemo(() => {
    let max = new Date().getFullYear()
    let min = SCHOOL_CYCLE_STARTS_AT
    let years = []

    for (let i = max; i >= min; i--) {
      years.unshift(i)
    }

    return years.map((year) => (
      <MenuItem key={year} value={`${year}`}>
        Año {year}
      </MenuItem>
    ))
  },[])

  return (
    <FormControl
      className={
        'inline-flex flex-row flex-nowrap items-center gap-3 ' + wrapperClasses
      }
    >
      <FormLabel className={'mb-0 ' + labelClasses}>Ciclo escolar:</FormLabel>
      <Select
        variant="outlined"
        className={`mt-0 ${selectClasses}`}
        {...selectProps}
      >
        {schoolCycleOptions}
      </Select>
    </FormControl>
  )
}

export default SchoolCycleSelect
